import React from 'react';
import './GoogleAuthNotice.css';

interface GoogleAuthNoticeProps {
  /** The message the server wrote on the paused calendars ('' for none). */
  message: string;
  /** The existing Google calendar connect flow — the same fix, not a new one. */
  onReconnect: () => void;
}

/**
 * A lost Google grant, said once above the Google calendars: the server paused
 * every enabled one with the same message, and one account problem must not
 * read as one problem per calendar. Errors are brick; no tinted card, no rail.
 */
export const GoogleAuthNotice: React.FC<GoogleAuthNoticeProps> = ({ message, onReconnect }) => (
  <div className="gcal-auth-notice" data-testid="gcal-auth-notice">
    {message && <p className="gcal-auth-notice-text">{message}</p>}
    <button type="button" className="gcal-auth-notice-btn" onClick={onReconnect}>
      Reconnect Google
    </button>
  </div>
);

export default GoogleAuthNotice;
